<span class="error pt-3">
	<ng-content></ng-content>
</span>
